export default [{
  path: '/view/installment',
  name: 'installmentview',
  component: () => import('@/app/installment/InstallmentView'),
  meta: {
    resource: 'installment',
    actions: ['read', 'write', 'delete']
  }
}]
